document.addEventListener("DOMContentLoaded", () => {
	const MAX_SIZE_BYTES = 50 * 1024 * 1024; // 50 МБ
	const container = document.querySelector("#mfcf7_zl_multifilecontainer");

	if (!container) return;

	const findSizeTextElement = () => {
		const listItems = document.querySelectorAll(".complain-form__list-item");
		for (const item of listItems) {
			if (item.textContent.includes("Общий размер всех загруженных файлов")) {
				return item;
			}
		}
		return null;
	};

	const calculateTotalSize = () => {
		const fileInputs = container.querySelectorAll('input[type="file"]');
		let totalSize = 0;

		fileInputs.forEach((input) => {
			if (input.files && input.files.length > 0) {
				Array.from(input.files).forEach((file) => {
					totalSize += file.size;
				});
			}
		});

		return totalSize;
	};

	const highlightError = (isError) => {
		const sizeTextElement = findSizeTextElement();
		if (!sizeTextElement) return;

		if (isError) {
			sizeTextElement.classList.add("complain-form__list-item--error");
		} else {
			sizeTextElement.classList.remove("complain-form__list-item--error");
		}
	};

	const validateFileSize = (e) => {
		const form = e.currentTarget || e.target.closest(".wpcf7-form") || e.target;
		if (!form || form.tagName !== "FORM" || !form.contains(container)) {
			highlightError(false);
			return;
		}

		const totalSize = calculateTotalSize();

		if (totalSize > MAX_SIZE_BYTES) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			highlightError(true);

			const sizeTextElement = findSizeTextElement();
			if (sizeTextElement) {
				setTimeout(() => {
					sizeTextElement.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
					});
				}, 100);
			}

			return false;
		}

		highlightError(false);
		return true;
	};

	const form = container.closest(".wpcf7-form");
	if (form) {
		form.addEventListener("submit", validateFileSize, true);

		const fileInputs = container.querySelectorAll('input[type="file"]');
		fileInputs.forEach((input) => {
			input.addEventListener("change", () => {
				const totalSize = calculateTotalSize();
				if (totalSize <= MAX_SIZE_BYTES) {
					highlightError(false);
				}
			});
		});
	}
});
